const defaultIDs = {
  "KS85FDHG": {
    sku: "B1",
    redirect_url: "/pages/blunder-vault",
    length: 9,
    passcode: [15, 9, 90, 13, 21, 31, 68, 64, 3]
  },
  "493CDWX4": {
    sku: "THD13",
    redirect_url: "/pages/deceit-vault",
    length: 9,
    passcode: [12, 57, 47, 39, 1, 29, 28, 52, 81]
  },
  "FEST3404": {
    sku: "TSS1",
    redirect_url: "/pages/secret-set-vault",
    length: 9,
    passcode: [52,29,80,17,60,43,18,22,13]
  },
  "KH478363": {
    sku: "TI1",
    redirect_url: "/pages/inheritance-vault",
    length: 9,
    passcode: [13,16,73,6,9,6,26,51,17]
  },
  "KNTGWDST": {
    sku: "TSA1",
    redirect_url: "/pages/sabotage-vault",
    length: 9,
    passcode: [22,15,41,24,5,12,35,42,26]
  },
  "GLCR24": {
    sku: "TDIS1",
    redirect_url: "/pages/disappearance-vault",
    length: 9,
    passcode: [12,43,29,12,17,84,61,87,74]
  },
  "PQXGCQVB": {
    sku: "DP1",
    redirect_url: "/pages/scandal-vault",
    length: 9,
    passcode: [21,35,6,4,13,7,40,12,38]
  },
  "GHDKJNTY": {
    sku: "TC1",
    redirect_url: "/pages/confession-vault",
    length: 9,
    passcode: [45,33,65,68,58,25,21,30,20]
  },
  "BULLSEYE": {
    sku: "TU1",
    redirect_url: "/pages/underdog-vault",
    length: 9,
    passcode: [3,25,67,53,15,70,39,92,48]
  },
  "DGA53UZI": {
    sku: "TCL1",
    redirect_url: "/pages/coast-line-default",
    length: 7,
    passcode: [35,52,4,18,17,30,18]
  },
  "WNTKSUJS": {
    sku: "MF1",
    redirect_url: "/pages/missed-flight-default",
    length: 7,
    passcode: [18,97,36,19,15,8,4]
  },
  "WMVTPJPH": {
    sku: "TS1",
    redirect_url: "/pages/split-default",
    length: 7,
    passcode: [15,11,74,8,5,10,4]
  },
  "WADKWCGX": {
    sku: "HS1",
    redirect_url: "/pages/dupe-default",
    length: 7,
    passcode: [27,97,4,5,32,8,1]
  },
  "836476X": {
    sku: "EX101",
    redirect_url: "/pages/explorer-default",
    length: 8,
    passcode: [8,12,3,8,5,7,20,2]
  },
  "DDUXVNBG": {
    sku: "EX101",
    redirect_url: "/pages/explorer-default",
    length: 8,
    passcode: [8,12,3,8,5,7,20,2]
  },
  "D6RNDFNS": {
    sku: "Z101",
    redirect_url: "/pages/zoo-default",
    length: 7,
    passcode: [4,4,19,12,19,13,12],
  },
  "TDFLVV2G": {
    sku: "SP1",
    redirect_url: "/pages/space-default",
    length: 7,
    passcode: [2,1,8,7,3,10,7],
  },
    "WRWHVSUE": {
    sku: "SS1",
    redirect_url: "/pages/secret-service-default",
    length: 9,
    passcode: [3,8,5,10,6,6,10,2,7],
  },
    "DRCNLS4H": {
    sku: "HHH101",
    redirect_url: "/pages/horrid-henry-home-default",
    length: 8,
    passcode: [10,3,6,3,10,5,4,8],
  },
    "DKWM5VFT": {
    sku: "HHS101",
    redirect_url: "/pages/horrid-henry-school-default",
    length: 8,
    passcode: [3,7,8,4,5,9,10,3],
  },
  "TNDTHSAG": {
    sku: "CP1",
    redirect_url: "/pages/elf-hq-default",
    length: 6,
    passcode: [9,1,4,3,7,5],
  },
  "D4NIEL": {
    sku: "TA1",
    redirect_url: "/pages/the-affair-vault",
    length: 9,
    passcode: [36,42,4,20,67,26,82,87,47],
  },
  "SILVERSCREEN": {
    sku: "BE1",
    redirect_url: "/pages/the-betrayal-vault",
    length: 9,
    passcode: [47,48,17,81,91,13,19,36,3],
  },
  "FESTIVE": {
    sku: "PX1",
    redirect_url: "/pages/festive-padlockd-testing-vault",
    length: 3,
    passcode: [6,0,6],
  },
  "BOTANICAL": {
    sku: "TR1",
    redirect_url: "/pages/the-ransom-vault",
    length: 9,
    passcode: [20,76,23,32,40,13,19,26,80],
  },
  "HEIST": {
    sku: "TH1",
    redirect_url: "/pages/the-heist-vault",
    length: 9,
    passcode: [40,75,40,83,58,32,70,23,35],
  },
  "COLLECTION": {
    sku: "XX1",
    redirect_url: "/pages/what-he-left-behind-vault",
    length: 7,
    passcode: [54,97,4,76,32,8,1],
  },
  "TRUTH": {
    sku: "XX2",
    redirect_url: "/pages/too-close-to-the-truth-vault",
    length: 7,
    passcode: [41,97,65,19,49,8,4],
  }
};